/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Outlook_Humanize_ErrorInputs */



/**
* | output |
* | --- |
* | "The rewrite failed. Please try again." |
*
* @param {Chat_Outlook_Humanize_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_outlook_humanize_error = /** @type {((inputs?: Chat_Outlook_Humanize_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Outlook_Humanize_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Umformulierung ist fehlgeschlagen. Bitte erneut versuchen.")
	return /** @type {LocalizedString} */ ("The rewrite failed. Please try again.")
});